import React, {Component} from '../../lib/react'
import {Button, message, Spin, Form, Col, Row} from 'antd'
import { hashHistory } from 'react-router';
import Recaptcha from 'react-recaptcha';

import { auth, database, initUser } from '../../services/firebase/firebase'

import ImageUpload from '../Items/ImageUploader';
import Input from '../UI/Input/Input';

import { updateObject, checkValidaty } from '../../shared/utility';

import styles from  './login.module.scss'

const defaultPlaceholderImage = "https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2Fplaceholder.png?alt=media&token=18740d81-a9cd-4c0c-b98e-8f93cb4fa52c";

class Login extends Component {
  state = {
    controls: {
      auth: {
        email: {
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Enter your email here...'
          },
          value: '',
          validation: {
            required: true,
            isEmail: true
          },
          valid: false,
          touched: false
        },
        password: {
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Enter password here...'
          },
          value: '',
          validation: {
            required: true,
            minLength: 6
          },
          valid: false,
          touched: false
        }
      },
      forgotPasword: {
        email: {
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Enter your email here...'
          },
          value: '',
          validation: {
            required: true,
            isEmail: true
          },
          valid: false,
          touched: false
        }
      },
      registration: {
        email: {
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Enter your email here...'
          },
          value: '',
          validation: {
            required: true,
            isEmail: true
          },
          valid: false,
          touched: false
        },
        displayName: {
          elementType: 'input',
          elementConfig: {
            type: 'text',
            placeholder: 'Type a name to display...'
          },
          value: '',
          validation: {

          },
          valid: false,
          touched: false
        },
        password: {
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Enter password here...'
          },
          value: '',
          validation: {
            required: true,
            minLength: 6
          },
          valid: false,
          touched: false
        },
        repassword: {
          elementType: 'input',
          elementConfig: {
            type: 'password',
            placeholder: 'Confirm password...'
          },
          value: '',
          validation: {
            required: true,
            minLength: 6
          },
          valid: false,
          touched: false
        },
        biography: {
          elementType: 'textarea',
          elementConfig: {
            type: 'textarea',
            rows: 5,
            placeholder: 'Type your biography here...'
          },
          value: '',
          validation: {
            required: true,
            minLength: 6
          },
          valid: false,
          touched: false
        },
      },
    },
    isVerified: false,
    PhotoUrl: "" ,
    thumbnailName: "" ,
    isImageDataSent: true,
  };

  constructor(props) {
    super(props);

    this.verifyCallback = this.verifyCallback.bind(this);
    this.callback = this.callback.bind(this);
    this.expiredCallback = this.expiredCallback.bind(this);
  }

  inputChangeHandler = (event, type, controlName) => {
    const updatedProperty = updateObject(this.state.controls[type][controlName], {
      value: event.target.value,
      valid: checkValidaty(event.target.value, this.state.controls[type][controlName].validation),
      touched: true
    });
    const updatedPartControls = updateObject(this.state.controls[type], {
      [controlName]: updatedProperty
    });
    const updatedControls = updateObject(this.state.controls, { [type]: updatedPartControls} );

    this.setState({controls: updatedControls});
  }

  loginWithGoogle() {
    let provider = new auth.GoogleAuthProvider();
    this.loginWithOtherAcc(provider)
  }

  loginWithFacebook() {
    let provider = new auth.FacebookAuthProvider();
    this.loginWithOtherAcc(provider)
  }

  async loginWithOtherAcc(provider){
    this.props.setStateHandler('sendingFormData');
    auth().useDeviceLanguage();
    //todo router.goto('/profile')
    return await auth().signInWithRedirect(provider)
  }

  async loginWithEmail() {
    const { hide, activeType } = this.props;
    const { isVerified } = this.state;

    const email = this.state.controls[activeType].email.value;
    const password = this.state.controls[activeType].password.value;

    let repassword, PhotoUrl, displayName, biography, thumbnailName;
    if (activeType !== 'auth') {
      repassword = this.state.controls[activeType].repassword.value;
      displayName = this.state.controls[activeType].displayName.value;
      biography = this.state.controls[activeType].biography.value;
      PhotoUrl = this.state.PhotoUrl;
      thumbnailName = this.state.thumbnailName;
    }

    if (!email) {
      return message.error('Email field is required');
    }

    if (!password) {
      return message.error('Password field is required');
    }

    if (activeType !== 'auth' && !repassword) {
      return message.error('Confirmation password is required');
    }

    if (activeType !== 'auth' && password !== repassword) {
      return message.error(' Sorry, but the password and its confirmation do not match. Please try again.');
    }

    if (activeType === 'registration' && !isVerified) {
      return message.error('Please verify that are you not a robot!');
    }

    const request = () => activeType === 'auth' ?
      auth().signInWithEmailAndPassword(email, password) :
      auth().createUserWithEmailAndPassword(email, password);

    try {
      this.props.setStateHandler('sendingFormData');
      let result = await request();
      let user = result.user;

      if (user && activeType !== 'auth') {
        const uid = user.uid;
        const DisplayName = displayName || user.email.split('@').slice(0, -1).join('.');
        await database.ref(`users/${uid}/`).set({
          Email: user.email,
          DisplayName: DisplayName,
          PhotoUrl: PhotoUrl || defaultPlaceholderImage,
          thumbnailName: thumbnailName || '',
          biography: biography || '',
        });
      }

      if (user) {
        await initUser(user.uid, user.email, user.displayName);
        this.props.redirect && hashHistory.push(`/Channels`);
      }

      if (hide) hide()
    }
    catch (err) {
      console.error('loginWithEmail error', err);
      let code = err.code;
      if (code === 'auth/wrong-password')
        message.error('Wrong password');
      else if (code === 'auth/weak-password')
        message.error('Weak password');
      else
        message.error(`Authentication error: ${code}`);

      this.props.setStateHandler(activeType);
    }
  }

  async forgotPassword(){
    const { value } = this.state.controls.forgotPasword.email;
    if (!value) {
      return message.error('Email field is required');
    }

    auth().sendPasswordResetEmail(value);
    message.success('Email sent');
    this.setState({refresh: Math.random()})
  }

  handleUpdateImage(url, thumbnailName) {
    this.setState({
      PhotoUrl: url,
      thumbnailName: thumbnailName,
      isImageDataSent: false,
    });
  }

  updatePassRecoveryStage = (type) => {
    this.props.setStateHandler(type);
  }

  callback = () => {
    console.log('Captcha is ready!');
  }

  verifyCallback = (response) => {
    if (response) {
      this.changeVerifiedStatus();
    }
  }

  expiredCallback = () => {
    this.changeVerifiedStatus();
  }

  changeVerifiedStatus = () => {
    this.setState((prevState) => {
      return {
        isVerified: !prevState.isVerified
      }
    });
  }

  render() {
    const { activeType, activeSubType } = this.props;
    let phase = activeType;

    if (activeSubType && activeSubType.length > 0) {
      phase = activeSubType
    }

    const formElementsArray = [];
    for (let key in this.state.controls[phase]) {
      formElementsArray.push({
        id: key,
        config: this.state.controls[phase][key]
      });
    }

    let form = formElementsArray.map(formElement => (
      <Input
        label={formElement.id}
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        invalid={!formElement.config.valid}
        changed={(event) => this.inputChangeHandler(event, phase, formElement.id)}
      />
    ));

    let outputForm = (
      <div className="login">
        <Row>
          <Col xs={24} md={12}>
            <Form
              onSubmit={(e) => {
                e.preventDefault()
                this.loginWithEmail()
              }}
              className="edit-form"
            >
              {form}
              <Form.Item className="form-center-buttons">
                <Row>
                  <Col>
                    {this.state.preloader ? (
                      <Spin />
                    ) : (
                      <Button name="next" className="login-form-button" type="primary" htmlType='submit'>Sign In</Button>
                    )}
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item className="forgot-password">
                <div className={styles.formControls}>
                  <a onClick={() => this.props.setStateSubHandler("forgotPasword")}>Forgot your password?</a>
                  <a onClick={() => this.props.setStateHandler('registration')}> Not a user? Sign Up here.</a>
                </div>
              </Form.Item>
            </Form>
            <Form>
              <Form.Item className="form-center-buttons">
                or
                <Row gutter={20}>
                  <Col span={12}>
                    <Button
                      type="primary"
                      className={styles.facebookButton}
                      onClick={this.loginWithFacebook}
                    >
                      Sign In with Facebook
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      className={styles.googleButton}
                      onClick={this.loginWithGoogle}
                    >
                      Sign In with Google
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    );

    if (activeType === "auth" && activeSubType === "forgotPasword") {
      outputForm = (
        <div className="login">
          <Row>
            <Col xs={24} md={12}>
              <Form
                className="edit-form"
                onSubmit={(e) => {
                  e.preventDefault()
                  this.forgotPassword()
                }}
              >
                {form}
                <Form.Item className="form-center-buttons">
                  <Row>
                    <Col>
                      {
                        this.state.preloader ? (
                          <Spin />
                        ) : (
                          <Button name="next" className="login-form-button" type="primary" htmlType='submit'>Send new password</Button>
                        )
                      }
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item className="forgot-password">
                  <a onClick={() => this.props.setStateSubHandler('')}>Go back</a>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      )
    }

    if(activeType === 'registration') {
      outputForm = (
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            this.loginWithEmail()
          }}
          className="edit-form"
        >
          <Row type="flex">
            <Col
              xs={24}
              md={{ span: 11, push: 1, order: 2 }}
              className="center-column"
            >
              <ImageUpload
                className="avatar-uploader"
                uploadText="Add Photo"
                isImageDataSent={this.state.isImageDataSent}
                imageUrl={this.state.PhotoUrl || ''}
                thumbnailName={this.state.thumbnailName || ''}
                onImageUpload={(url, thumbnailName) => this.handleUpdateImage(url, thumbnailName)}
              />
            </Col>
            <Col xs={24} md={12}>
              {form}
              {
                this.props.captchaId && <Recaptcha
                  sitekey="6LeP3qsUAAAAAMBxL6Kp9pJFL1TaA6UDLKvIuckN"
                  render="explicit"
                  onloadCallback={this.callback}
                  elementID={this.props.captchaId}
                  verifyCallback={this.verifyCallback}
                  expiredCallback={this.expiredCallback}
                />
              }
            </Col>
          </Row>

          <Row type="flex" className="edit-form-button-bar">
            <Col xs={24} md={12}>
              <Form.Item className="form-center-buttons">
                <Row>
                  <Col>
                    <Button
                      name="login"
                      type="primary"
                      htmlType='submit'
                    >
                      Sign Up
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      );
    }
    if (activeType === 'sendingFormData') {
      outputForm = <div className="login"> <Spin /> </div>
    }

    return outputForm;
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/Login.js